import { FC } from 'react'

import { Nullable } from 'clickNgo/models/utils'

import styles from './ProductExhibitsReadMode.module.scss'

interface IProductExhibitsReadModeProps {
  exhibits: Nullable<string>
}

export const ProductExhibitsReadMode: FC<IProductExhibitsReadModeProps> = ({ exhibits }) => {
  return (
    <div className={styles.root}>
      <span>{exhibits ? exhibits : <b>-</b>}</span>
    </div>
  )
}
